import { render } from "./PromotionHistory.vue?vue&type=template&id=30f8bd42&ts=true"
import script from "./PromotionHistory.vue?vue&type=script&lang=ts"
export * from "./PromotionHistory.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__